export enum RafpRequestStatusTypeEnum {
  REQUEST_SENT = 'REQUEST_SENT',
  SUCCESS = 'SUCCESS',
  NOT_FOUND = 'NOT_FOUND',
  ERROR_RETRY = 'ERROR_RETRY',
}
